import { BaseEntity } from '../../../../models';
import { TabelaPreco } from '../../../tabela-preco';
import { PacoteCampanhaTabelaPreco } from '../../pacotes/tabelas-precos';

export class CampanhaTabelaPreco implements BaseEntity {
    readonly id: number;
    idCampanha: number;
    idTabelaPreco: number;
    tabelaPreco: TabelaPreco;
}

/** Realiza o map da tabela de preço do pacote para a campanha */
export function mapFromPacoteCampanhaTabelaPreco(idCampanha: number, pacoteTabelaPreco: PacoteCampanhaTabelaPreco): CampanhaTabelaPreco {
    if (!pacoteTabelaPreco) {
        return null;
    }

    const campanhaTabelaPreco = new CampanhaTabelaPreco();
    campanhaTabelaPreco.idCampanha = idCampanha;
    campanhaTabelaPreco.idTabelaPreco = pacoteTabelaPreco.idTabelaPreco
    campanhaTabelaPreco.tabelaPreco = pacoteTabelaPreco.tabelaPreco;

    return campanhaTabelaPreco;
}
